module.exports = __webpack_public_path__ + "static/media/background_1.a46588e8.png";